import { useState, useEffect } from "react";

const whatsappUrl = "https://wa.me/qr/B5BVPSPSXGEBM1";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
    setMenuOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled ? "bg-white/95 backdrop-blur-md shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 md:px-10 flex items-center justify-between h-16 md:h-20">
        {/* Logo */}
        <button onClick={() => scrollTo("hero")} className="flex items-center gap-3 cursor-pointer">
          <img
            src="https://storage.readdy-site.link/project_files/ce59911f-28b4-45a2-8552-b6e34b0cb888/565bbfd8-15cf-468d-9786-627256391135_ChatGPT-Image-28-de-abr.-de-2026-12_05_18-1.png?v=d797f6a003fce23206b119914056a133"
            alt="Vynora Pisos Logo"
            className="h-8 md:h-10 w-auto object-contain"
          />
        </button>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8">
          {[
            { label: "Início", id: "hero" },
            { label: "Galeria", id: "galeria" },
            { label: "Benefícios", id: "beneficios" },
            { label: "Sobre", id: "sobre" },
            { label: "Depoimentos", id: "depoimentos" },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className={`text-sm font-medium tracking-wide transition-colors cursor-pointer whitespace-nowrap ${
                scrolled ? "text-stone-700 hover:text-amber-700" : "text-white/90 hover:text-amber-300"
              }`}
            >
              {item.label}
            </button>
          ))}
        </div>

        {/* CTA Button - WhatsApp */}
        <a
          href={whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="hidden md:flex items-center gap-2 bg-amber-700 hover:bg-amber-800 text-white text-sm font-semibold px-6 py-3 rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer"
        >
          Solicitar Orçamento
        </a>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden w-8 h-8 flex flex-col justify-center gap-1.5 cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menu"
        >
          <span className={`block h-0.5 w-full transition-all duration-300 ${scrolled ? "bg-stone-800" : "bg-white"} ${menuOpen ? "rotate-45 translate-y-2" : ""}`} />
          <span className={`block h-0.5 w-full transition-all duration-300 ${scrolled ? "bg-stone-800" : "bg-white"} ${menuOpen ? "opacity-0" : ""}`} />
          <span className={`block h-0.5 w-full transition-all duration-300 ${scrolled ? "bg-stone-800" : "bg-white"} ${menuOpen ? "-rotate-45 -translate-y-2" : ""}`} />
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-stone-100 px-5 py-4 flex flex-col gap-1">
          {[
            { label: "Início", id: "hero" },
            { label: "Galeria", id: "galeria" },
            { label: "Benefícios", id: "beneficios" },
            { label: "Sobre", id: "sobre" },
            { label: "Depoimentos", id: "depoimentos" },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="text-stone-700 font-medium text-sm text-left cursor-pointer hover:text-amber-700 transition-colors py-2.5 border-b border-stone-50 last:border-0"
            >
              {item.label}
            </button>
          ))}
          <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-3 bg-amber-700 text-white font-semibold py-3 rounded-full cursor-pointer whitespace-nowrap text-sm text-center inline-block"
          >
            Solicitar Orçamento
          </a>
        </div>
      )}
    </nav>
  );
}